import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { UserService } from '../../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    RouterModule,
    MatProgressBarModule,
    CommonModule,
  ],
  templateUrl: './forgot-password-page.component.html',
  styleUrl: './forgot-password-page.component.scss',
})
export class ForgotPasswordPageComponent {
  loading: boolean = false;

  forgotPasswordForm = new FormGroup({
    emailFormControl: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
  });

  constructor(
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {}

  onSubmit() {
    this.loading = true;
    this.userService
      .forgotPassword(this.forgotPasswordForm.value.emailFormControl!)
      .subscribe({
        next: () => {
          this.loading = false;
          this.snackBar.open(
            'A password reset email will be sent to the provided email address.',
            '',
            {
              duration: 3000,
            }
          );
        },
        error: () => {
          this.loading = false;
          this.snackBar.open(
            'An email to reset your password will be sent to the provided email address.',
            '',
            {
              duration: 3000,
            }
          );
        },
      });
  }
}
